module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container plan-payment"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v("รายละเอียดบริการ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.doctor.subscriptions), function(sub) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(sub.id))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.plans[sub.plan_id - 1].name)), _c('br'), _vm._v("\n                  " + _vm._s(_vm.plans[sub.plan_id - 1].detail)), _c('br'), _vm._v("\n                  " + _vm._s(_vm.plans[sub.plan_id - 1].duration)), _c('br')]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sub.started_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sub.expired_at))]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _vm._m(3, true)])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("My subscription")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Detail")]), _vm._v(" "), _c('th', [_vm._v("Start Date")]), _vm._v(" "), _c('th', [_vm._v("Expired Date")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Bill")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v(" Active")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Receipt")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcf6c7f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/package/MySubscription.vue
// module id = 1057
// module chunks = 1